export default __webpack_public_path__ + "static/media/your-website.3fffeb41.svg";